import axiosProxy from './setting';
import store from "@/store";

//
import { isApp } from '@u/appHelper';

export function setNotifyToken() {
  // appCallAlert('[setNotifyToken]\nnotifyToken: ' + JSON.stringify(store.state.cache.notifyToken) + '\ntoken: ' + JSON.stringify(store.state.cache.token));
  if (!isApp() || BUILD_MODE === 'dev') return Promise.resolve();

  return axiosProxy({
    url: '/app/users/me/notifyTokens',
    method: 'post',
    data: {
      token: store.getters.notifyToken
    }
  })
}